const NAMESPACE = 'SEARCH_DATA';

const REMOVE_SEARCH_PARAMS = `${NAMESPACE}/REMOVE_SEARCH_PARAMS`;
const SET_SEARCH_PARAMS = `${NAMESPACE}/SET_SEARCH_PARAMS`;
const SET_INPUT_PARAMS = `${NAMESPACE}/SET_INPUT_PARAMS`;
const SET_DIRECTION = `${NAMESPACE}/SET_DIRECTION`;
const SET_DEPART_TRIP_ID = `${NAMESPACE}/SET_DEPART_TRIP_ID`;
const SET_RETURN_TRIP_ID = `${NAMESPACE}/SET_RETURN_TRIP_ID`;
const REMOVE_DEPART_TRIP_ID = `${NAMESPACE}/REMOVE_DEPART_TRIP_ID`;
const REMOVE_RETURN_TRIP_ID = `${NAMESPACE}/REMOVE_RETURN_TRIP_ID`;
const SET_USER_PLACE_ID = `${NAMESPACE}/SET_USER_PLACE_ID`;
const SET_ORIGIN_USER_INPUT = `${NAMESPACE}/SET_ORIGIN_USER_INPUT`;
const SET_DESTINATION_USER_INPUT = `${NAMESPACE}/SET_DESTINATION_USER_INPUT`;
const SET_SERVER_BATCH_ID = `${NAMESPACE}/SET_SERVER_BATCH_ID`;
const SET_QUERY_PARAMS = `${NAMESPACE}/SET_QUERY_PARAMS`;
const SET_PASSENGERS_INPUT = `${NAMESPACE}/SET_PASSENGERS_INPUT`;

export {
    REMOVE_DEPART_TRIP_ID,
    REMOVE_RETURN_TRIP_ID,
    REMOVE_SEARCH_PARAMS,
    SET_DEPART_TRIP_ID,
    SET_DESTINATION_USER_INPUT,
    SET_DIRECTION,
    SET_INPUT_PARAMS,
    SET_ORIGIN_USER_INPUT,
    SET_PASSENGERS_INPUT,
    SET_QUERY_PARAMS,
    SET_RETURN_TRIP_ID,
    SET_SEARCH_PARAMS,
    SET_SERVER_BATCH_ID,
    SET_USER_PLACE_ID,
};

export default NAMESPACE;
